import { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Form, Stack, Table, FormSelect } from 'react-bootstrap';
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Modal from "react-bootstrap/Modal";
import { FcPlus, FcList, FcSearch, FcApproval, FcDataConfiguration } from "react-icons/fc";
import { TiEdit, TiDeleteOutline } from "react-icons/ti";

import ProcessFileService from "../../services/processFile.service";
import TempProjectFileDataService from "../../services/tempProjectFile.service";
import ProjectFileDataService from "../../services/projectFile.service";
import ProjectStructureService from "../../services/projectStructure.service";
import ProjectDataService from "../../services/project.service";
import SupplierDataService from "../../services/supplier.service";

import FormInputText from "../../components/FormField/FormInput";
import FormInputSelect from "../../components/FormField/FormSelect";
import FormCheckbox from "../../components/FormField/FormCheckbox";
import TableRow from '../../components/layout/TableRow';
import TableColumnRow from '../../components/layout/TableColumnRow';
import { fileFormatList, columnIndexList, columnConditionList, inputFileTypeList } from '../../constant/index';
import { useAuthContext } from "../../contexts/AuthContext";

import "./ProjectFile.scss";


function ProjectFileCreate() {

  const navigate = useNavigate();
  const location = useLocation();
  const { setIsLoading } = useAuthContext();

  let { projectId, projectFileId } = useParams();
  const [project, setProject] = useState();
  const [projectFile, setProjectFile] = useState("");
  const [projectMasterKeys, setProjectMasterKeys] = useState([]);
  const [recordTypeArray, setRecordTypeArray] = useState([]);
  const [recordTypes, setRecordTypes] = useState([]);
  const [masterProjectFileType, setMasterProjectFileType] = useState();
  const [supplier, setSupplier] = useState();
  const [fileFormat, setFileFormat] = useState();
  const [fileFormatId, setFileFormatId] = useState();
  const [fileFormatName, setFileFormatName] = useState();
  const [delimitor, setDelimitor] = useState();
  const [hasHeader, setHasHeader] = useState(false);
  const [includeTrailer, setIncludeTrailer] = useState(false);
  const [headers, setHeaders] = useState();
  const [previewTable, setPreviewTable] = useState({});
  const [fileNamePattern, setFileNamePattern] = useState();
  const [fileRecordLength, setFileRecordLength] = useState();
  const [metaDataFieldName, setMetaDataFieldName] = useState();
  const [metaDataFieldValue, setMetaDataFieldValue] = useState();
  const [metadata, setMetadata] = useState([]);
  const [showMetadata, setShowMetadata] = useState(false);
  const [supplierNameRow, setSupplierNameRow] = useState();
  const [periodRangeRow, setPeriodRangeRow] = useState();
  const [dataHeaderRow, setDataHeaderRow] = useState();
  const [mergedCell, setMergedCell] = useState();
  const [splitCell, setSplitCell] = useState();
  const [splitCellString, setSplitCellString] = useState();
  const [validationColumn, setValidationColumn] = useState();
  const [exceptionKeywords, setExceptionKeywords] = useState();
  const [isMultipleString, setIsMultipleString] = useState(false);
  const [isComapnyGreater, setIsComapnyGreater] = useState(false);
  const [isBillNoinRow, setIsBillNoinRow] = useState(false);
  const [billNoColumn, setBillNoColumn] = useState();
  const [multipleStringFormat, setMultipleStringFormat] = useState();
  const [supplierName, setSupplierName] = useState();
  const [periodRange, setPeriodRange] = useState();
  const [masterProjectFileTypeRow, setMasterProjectFileTypeRow] = useState();
  const [projectFileName, setProjectFileName] = useState("");
  const [supplierList, setSupplierList] = useState([]);
  const [supplierFilteredList, setSupplierFilteredList] = useState([]);
  const [showModalSupplier, setShowModalSupplier] = useState(false);
  const [supplierNameTxt, setSupplierNameTxt] = useState("");
  const [supplierCodeTxt, setSupplierCodeTxt] = useState("");
  const [supplierAddressTxt, setSupplierAddressTxt] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [file, setFile] = useState(null);
  const [testRunBtn, setTestRunBtn] = useState(true);
  const [viewTable, setViewTable] = useState(false);
  const [rows, setRows] = useState();
  const [spaceTab, setSpaceTab] = useState();
  const [isFixedLength, setIsFixedLength] = useState(false);
  const [fixedLengthFormat, setFixedLengthFormat] = useState();

  const [companyNameReversed, setCompanyNameReversed] = useState(false);
  const [companyNameInColumns, setCompanyNameInColumns] = useState(false);
  const [companyNameInRows, setCompanyNameInRows] = useState(false);
  const [companyNameRowsCount, setCompanyNameRowsCount] = useState(2);
  const [companyNameInColumnsIndex, setCompanyNameInColumnsIndex] = useState();
  const [compNameInRows, setCompNameInRows] = useState(false);
  

  const [addStaticHeader, setAddStaticHeader] = useState();
  const [skipRows, setSkipRows] = useState();
  const [isDataInSingleColumn, setIsDataInSingleColumn] = useState();
  const [isCompanyAndProductSequence, setIsCompanyAndProductSequence] = useState();
  const [doCaptureEmptyValidationColumnValue, setDoCaptureEmptyValidationColumnValue] = useState(false);
  const [secondaryValidationColumn, setSecondaryValidationColumn] = useState("");

  const [tableList, setTableList] = useState([]);
  const [selectedTableName, setSelectedTableName] = useState("");

  const locationPathName = location && location.pathname;
  let isClone = false, isEdit = false, isView = false, isCreate = false;
  if (projectFileId) {
    if (locationPathName.includes('/clone')) isClone = true;
    else if (locationPathName.includes('/edit')) isEdit = true;
    else if (locationPathName.includes('/detail')) isView = true;
  } else {
    isCreate = true;
  }

  useEffect(() => {
    if(projectFileId){
      retrieveFileConfigDetails(projectFileId);
    }
    retrieveProjectDetails(projectId);
    retrieveSupplierList();
    //if(isCreate) retrieveProjectStructureList();
  }, [projectId, projectFileId]);


  useEffect(() => {
    if(supplier){
      let text = [supplier.supplierCode, masterProjectFileType, fileFormatId].filter(Boolean).join(" - ");
      setProjectFileName(text);
    }
  }, [supplier, masterProjectFileType, fileFormatId]);


  function retrieveProjectDetails(projectId) {
    setIsLoading(true);
    ProjectDataService.get(projectId).then((response) => {
      setIsLoading(false);
      setProject(response.data.data);
      const fileRecordArray = response.data.data.masterKeys.map(item => {
        return { 
          "id": item._id,
          "name": item._id,
          "label": item.masterKeyName
        }
      });
      setRecordTypeArray(fileRecordArray);
      setProjectMasterKeys(response.data.data.masterKeys);
    });
  }

  


  // useEffect(() => {
  //   if(structure){
  //     setFileFormat(structure.fileFormat);
  //     setFileType(structure.fileType);
  //     setRecordType(structure.recordType);
  //   }
  // }, [structure]);

  useEffect(() => {
    if(projectFile){
      setRecordTypes(projectFile.recordTypes);
      setFileNamePattern(projectFile.fileNamePattern);
      setFileRecordLength(projectFile.fileRecordLength);
      setFileName(projectFile.file_Name);
      setMasterProjectFileType(projectFile.masterProjectFileType);
      setMetadata(projectFile.metadata);
      setProjectFileName(projectFile.projectFileName);
      setSupplier(projectFile.projectSupplierId);
      setFileFormat(projectFile.fileFormat);
      setFileFormatId(projectFile.fileFormatId);
      setFileFormatName(projectFile.fileFormatName);
      setSupplierNameRow(projectFile.supplierNameRow);
      setPeriodRangeRow(projectFile.periodRangeRow);
      setDataHeaderRow(projectFile.dataHeaderRow);
      setMergedCell(projectFile.mergedCell);
      setSplitCell(projectFile.splitCell);
      setSplitCellString(projectFile.splitCellString);
      setValidationColumn(projectFile.validationColumn);
      setExceptionKeywords(projectFile.exceptionKeywords);
      setDelimitor(projectFile.delimitor);
      setHasHeader(projectFile.hasHeader);
      setIncludeTrailer(projectFile.includeTrailer);
      setProjectMasterKeys([...projectFile.recordTypes]);
      setCompanyNameReversed(projectFile.companyNameReversed);
      setCompanyNameInColumns(projectFile.companyNameInColumns);
      setCompanyNameInRows(projectFile.companyNameInRows);
      setCompanyNameRowsCount(projectFile.companyNameRowsCount);
      setCompanyNameInColumnsIndex(projectFile.companyNameInColumnsIndex);
      setIsMultipleString(projectFile.isMultipleString);
      setIsComapnyGreater(projectFile.isComapnyGreater);
      setIsBillNoinRow(projectFile.isBillNoinRow);
      setBillNoColumn(projectFile.billNoColumn);
      setMultipleStringFormat(projectFile.multipleStringFormat);
      setMasterProjectFileTypeRow(projectFile.masterProjectFileTypeRow);
      setSpaceTab(projectFile.spaceTab);
      setIsFixedLength(projectFile.isFixedLength);
      setFixedLengthFormat(projectFile.fixedLengthFormat);
      setAddStaticHeader(projectFile.addStaticHeader);
      setSkipRows(projectFile.skipRows);
      setIsDataInSingleColumn(projectFile.isDataInSingleColumn);
      setCompNameInRows(projectFile.compNameInRows);
      setIsCompanyAndProductSequence(projectFile.isCompanyAndProductSequence);
      setDoCaptureEmptyValidationColumnValue(projectFile.doCaptureEmptyValidationColumnValue);
      setSecondaryValidationColumn(projectFile.secondaryValidationColumn);
      setSelectedTableName(projectFile.selectedTableName || "");
    }
  }, [projectFile]);

  useEffect(() => {

    if(projectFile && project){

      let projectFileMasterKeys = [...projectFile.recordTypes];
      let projectMasterKeys = [...project.masterKeys];

      let finalMergedRecordTypes = mergeArrayofObjects(projectMasterKeys, projectFileMasterKeys);

      setProjectMasterKeys([...finalMergedRecordTypes]);

    }

  }, [projectFile, project]);

  // Merge a `source` object to a `target` recursively
const mergeArrayofObjects = (target, source) => {
  // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
  for (const key of Object.keys(source)) {
    if (source[key] instanceof Object) Object.assign(source[key], mergeArrayofObjects(target[key], source[key]))
  }

  // Join `target` and modified `source`
  Object.assign(target || {}, source)
  return target
}


  function copy(source, destination) {
    for (let prop in source) {
        destination[prop] = source[prop];
    }
  }

  const mergeArray = (arr1,arr2) => {

    let newArray = [];
    for (let i = 0, obj1; obj1 = arr1[i]; ++i) {
        let obj = {};
        copy(obj1, obj);
        for (let j = 0, obj2; obj2 = arr2[j]; ++j) {
            if (obj1.name === obj2.name) {
                copy(obj2, obj);
            }
        }
        newArray.push(obj);
    }
    for (let i = 0, obj2; obj2 = arr2[i]; ++i) {
        let here = false;
        for (let j = 0, obj1; obj1 = arr1[j]; ++j) {
            if (obj1.name === obj2.name) {
                here = true;
            }
        }
        if (!here) {
            newArray.push(obj2);
        }
    }
    return newArray;
  }


  function retrieveFileConfigDetails(projectFileId) {
    setIsLoading(true);
    ProjectFileDataService.get(projectFileId).then((response) => {
      setIsLoading(false);
      setProjectFile(response.data && response.data.data && response.data.data[0]);
    });
  }

  function retrieveSupplierList() {
    setIsLoading(true);
    SupplierDataService.getByProject(projectId).then((response) => {
      setIsLoading(false);
      setSupplierList(response.data.data);
      setSupplierFilteredList(response.data.data);
    });
  }


  // const retrieveProjectStructureList = () => {
  //   ProjectStructureService.getByProject(projectId).then((response) => {
  //     const structureList = response.data.data.map(item => {
  //       return {
  //         "id": item.id,
  //         "name": item.id,
  //         "label": item.structureName,
  //         "checked": false,
  //         ...item
  //       }
  //     });
  //     console.log('structureList', structureList);
  //     setProjectStructureList(structureList);
  // 	});
	// }



  // const setFileTypeFunction  = (value) => {
  //   const selectedFileFormat = masterKeys.filter((item) => item._id === value);
  //   setFileType({
  //     name: selectedFileFormat[0].masterKeyName,
  //     id: value,
  //   });
  //   setSelectedFileFormat(selectedFileFormat[0]);
  //   if(isCreate) {
  //     setRecordType(selectedFileFormat[0].masterKeyFields);
  //   }
  // }

  const createEditProjectFile = () => {

    if(!projectId) {
      toast.warning("Project is required.");
      return true;
    }

    let finalFileName = fileName;
    if(file){
      finalFileName = file.name;
    }

    let data = {
      projectId,
      masterProjectFileType,
      recordTypes,
      projectSupplierId: supplier.id || supplier._id,
      fileFormat,
      fileFormatId,
      fileFormatName,
      projectFileName,
      fileNamePattern,
      fileRecordLength,
      file_Name: finalFileName,
      supplierNameRow,
      periodRangeRow,
      masterProjectFileTypeRow,
      dataHeaderRow,
      mergedCell,
      splitCell,
      splitCellString,
      validationColumn,
      exceptionKeywords,
      isMultipleString,
      multipleStringFormat,
      delimitor,
      hasHeader,
      includeTrailer,
      metadata,
      companyNameReversed,
      companyNameInColumns,
      companyNameInRows,
      companyNameRowsCount,
      companyNameInColumnsIndex,
      isComapnyGreater,
      isBillNoinRow,
      billNoColumn,
      spaceTab,
      isFixedLength,
      fixedLengthFormat,
      addStaticHeader,
      skipRows,
      isDataInSingleColumn,
      compNameInRows,
      isCompanyAndProductSequence,
      doCaptureEmptyValidationColumnValue,
      secondaryValidationColumn,
      selectedTableName
    };


    if (isClone) {
      setIsLoading(true);
      ProjectFileDataService.clone(projectFileId, data).then((response) => {
        setIsLoading(false);
        if(response.data.success){
          toast.success("Project File Cloned!");
          navigate("/project/" + projectId + "/file");
        } else {
          toast.error("Error in cloning Project File");
        }
      });
    } else if(isEdit){
      setIsLoading(true);
      ProjectFileDataService.update(projectFileId, data).then((response) => {
        setIsLoading(false);
        if(response.data.success){
          toast.success("Project File Updated!");
          navigate("/project/" + projectId + "/file");
        } else {
          toast.error("Error in updating Project File");
        }
        
      });
    } else if(isCreate){
      setIsLoading(true);
      ProjectFileDataService.create(data).then((response) => {
        setIsLoading(false);
        if(response.data.success){
          toast.success("Project File Created!");
          navigate("/project/" + projectId + "/file");
        } else {
          toast.error("Error in creating Project File");
        } 
      });
    }
  };

  const handleCondtionColIndexChange = (value, checkItem) => {
    console.log('handleCondtionColIndexChange', value, checkItem);
    
    let recordItems = [...recordTypes];
    recordItems.map(item => {
      if(item._id === checkItem._id) {
        item.condtionColIndex = value;
      }
    });

    setRecordTypes(recordItems);
  }

  const handleCondtionColChange = (value, checkItem) => {
    console.log('handleCondtionColChange', value, checkItem);
    
    let recordItems = [...recordTypes];
    recordItems.map(item => {
      if(item._id === checkItem._id) {
        item.condtionCol = value;
      }
    });

    setRecordTypes(recordItems);
  }

  const handleCondtionColValueChange = (value, id) => {
    console.log('handleCondtionColValueChange', value, id);

    let recordItems = [...recordTypes];
    
    recordItems.map(item => {
      if(item._id === id) {
        item.condtionColValue = value;
      }
    });
    console.log('recordItems', recordItems);

    setRecordTypes(recordItems);
  }

  

  const handleHeaderChange = (value, name, keyName) => {
    console.log('handleHeaderChange', value, name, keyName);

    let recordItems = [...recordTypes];
    for(let ris = 0; ris < recordItems.length; ris ++){
      let recordItem = recordItems[ris];
      console.log('recordItem', recordItem);
      if(recordItem.masterKeyName === keyName){
        for(let ri = 0; ri < recordItem.masterKeyFields.length; ri ++){
            let masterKeyFields = recordItem.masterKeyFields[ri];
            if(masterKeyFields.fieldName === name) {
              masterKeyFields.fieldName = name;
              masterKeyFields.source = name;
              masterKeyFields.startPosition = Number(value);
              masterKeyFields.target = value === "Select Target Field" ? '' : value;
            }
        }
      }
    }

    setRecordTypes([...recordItems]);

  }

  const handleStartPositionChange = (value, name, keyName) => {
    console.log('handleStartPositionChange', value, name, keyName);

    let recordItems = [...recordTypes];
    for(let ris = 0; ris < recordItems.length; ris ++){
      let recordItem = recordItems[ris];
      console.log('recordItem', recordItem);
      if(recordItem.masterKeyName === keyName){
        for(let ri = 0; ri < recordItem.masterKeyFields.length; ri ++){
            let masterKeyFields = recordItem.masterKeyFields[ri];
            if(masterKeyFields.fieldName === name) {
              masterKeyFields.fieldName = name;
              masterKeyFields.source = name;
              masterKeyFields.startPosition = Number(value);
            }
        }
      }
    }

    setRecordTypes([...recordItems]);

  }

  const handleEndPositionChange = (value, name, keyName) => {

    let recordItems = [...recordTypes];
    for(let ris = 0; ris < recordItems.length; ris ++){
      let recordItem = recordItems[ris];
      console.log('recordItem', recordItem);
      if(recordItem.masterKeyName === keyName){
        for(let ri = 0; ri < recordItem.masterKeyFields.length; ri ++){
            let masterKeyFields = recordItem.masterKeyFields[ri];
            if(masterKeyFields.fieldName === name) {
              masterKeyFields.fieldName = name;
              masterKeyFields.source = name;
              masterKeyFields.endPosition = Number(value);
            }
        }
      }
    }

    setRecordTypes([...recordItems]);

  }

  const handlePositionLengthChange = (value, name, keyName) => {

    let recordItems = [...recordTypes];
    for(let ris = 0; ris < recordItems.length; ris ++){
      let recordItem = recordItems[ris];
      console.log('recordItem', recordItem);
      if(recordItem.masterKeyName === keyName){
        for(let ri = 0; ri < recordItem.masterKeyFields.length; ri ++){
            let masterKeyFields = recordItem.masterKeyFields[ri];
            if(masterKeyFields.fieldName === name) {
              masterKeyFields.fieldName = name;
              masterKeyFields.source = name;
              masterKeyFields.positionLength = Number(value);
            }
        }
      }
    }

    setRecordTypes([...recordItems]);
  }

  const onChangeSupplierSelected = (id) => {

    const selectedSupplier = supplierList.filter(item => item.id === id);
    const supplierCode = selectedSupplier[0].supplierCode;

    console.log('selectedSupplier', selectedSupplier[0]);

    setSupplier(selectedSupplier[0]);
    setProjectFileName(supplierCode);
  }

  const handleShowModalSupplier = () => {
    setShowModalSupplier(true);
  }

  const handleCloseModalSupplier = () => {
    setShowModalSupplier(false);
  }

  const onChangeSupplierNameTxt = (value) => {
    var str= value.toLowerCase();
    var supplier = supplierList.filter(function(data) {
      if(data.supplierName.toString().toLowerCase().includes(str)){
        return true
      }
    });
    setSupplierFilteredList(supplier);
    setSupplierNameTxt(value);
  }
  const onChangeSupplierCodeTxt = (value) => {

    var str= value.toLowerCase();
    var supplier = supplierList.filter(function(data) {
      if(data.supplierCode.toString().toLowerCase().includes(str)){
        return true
      }
    });
    setSupplierFilteredList(supplier);
    setSupplierCodeTxt(value);
  }
  const onChangeSupplierAddressTxt = (value) => {
    var str= value.toLowerCase();
    var supplier = supplierList.filter(function(data) {
      if(data.supplierAddress.toString().toLowerCase().includes(str)){
        return true
      }
    });
    setSupplierFilteredList(supplier);
    setSupplierAddressTxt(value);
  }

  const selectSupplier = (id) => {
    onChangeSupplierSelected(id);
    handleCloseModalSupplier();
  }

//   const onChangeProjectStructureSelected = (id) => {
//     console.log(id);
//     let selectedProjectStructure = projectStructureList.filter(item => item.id === id);
//     console.log('selectedProjectStructure', selectedProjectStructure);
//     let projectStructureName = selectedProjectStructure[0].label;

//     setShowStructureFormFields(true);
//     setProjectStructureSelected(id);
//     setProjectFileName(supplier.supplierCode + " - " + projectStructureName);
//     setRecordType(selectedProjectStructure[0].recordType);

//     retrieveProjectStructureDetails(id);
//  }

const onCheckedRecordTypeSelected = (id, checkedItem) => {
  console.log('onCheckedRecordTypeSelected.id >>> ', id);
  console.log('onCheckedRecordTypeSelected.item >>> ', checkedItem);

  
  projectMasterKeys.map(item => {
    if(item._id === checkedItem._id) {
      item.refId = checkedItem._id
      item.checked = !item.checked;
    }
  });
  setProjectMasterKeys([...projectMasterKeys]);


  let filterList = projectMasterKeys.filter((item) => item.checked);

  console.log('onCheckedRecordTypeSelected.filterList ', filterList);
  
  setRecordTypes(filterList);


  // setSupplierNameRow(structure.supplierNameRow);
  // setPeriodRangeRow(structure.periodRangeRow);
  // setDataHeaderRow(structure.dataHeaderRow);
  // setMergedCell(structure.mergedCell);
  // setValidationColumn(structure.validationColumn);
  // setExceptionKeywords(structure.exceptionKeywords);
  // setFileFormat(structure.fileFormat);
  // setStructure(structure);
  // setSupplierName(structure.supplierName);
  // setPeriodRange(structure.periodRange);







  // let projectStructureName = selectedProjectStructure[0].label;
  
  //setProjectFileList();
  
  //setProjectFileList();

  // setShowStructureFormFields(true);
  // setProjectStructureSelected(id);
  // setProjectFileName(supplier.supplierCode + " - " + projectStructureName);
  // setRecordType(selectedProjectStructure[0].recordType);

  //retrieveProjectStructureDetails(id);
}

// const retrieveProjectStructureDetails = (projectStructureId) => {
  
//   ProjectStructureService.get(projectStructureId).then((response) => {
//     let projectStructureDetails = response.data.data;

//     console.log('projectStructureDetails', projectStructureDetails);
//     setStructure(projectStructureDetails);

//   });
// }

const getFileExtension = (name) => {
  const parts = name.split('.');

  if (parts.length > 0) {
      return parts.pop();
  }

  return false;
}

// const isValidExtension = (name) => {
//   let extension = getFileExtension(name);
//   extension = extension && extension.toLowerCase() || '';
//   let result = false;
//   if(fileFormat === "textFile" || fileFormat === "TEXT File") {
//     result = extension === 'txt';
//   } else if(fileFormat === "excelFile" || fileFormat === "EXCEL File") {
//     result = (extension === 'xls' || extension === 'xlsx');
//   } else if(fileFormat === "csvFile") {
//     result = extension === 'csv';
//   }
//   return result;
// }

const readFile = (e) => {
  console.log('readFile');
  const { target } = e;
  let file = null;

  if (target.files && target.files.length > 0) {
      file = target.files[0];

      // validateFileAttached(file);

      // if (!isValidExtension(file.name)) {
      //   toast.error("File Extension Incorrect");
      //   return;
      // }
  }
  
  var data = {
      projectId:projectId,
      projectStructureName: projectFileName,
      fileFormat: fileFormat,
      file: file,
  }
  setIsLoading(true);
   TempProjectFileDataService.create(data)
    .then((response) => {
      setIsLoading(false);
      if(response.data.success){ // check for success
        if(response.data.success){
          //toast.success("Project File has been created successfully.!");
        }
        setFile(file);
        setFileName(response.data.data.file);
        viewOriginalFile(file);
      }else{
        if(response.data.err.message){ // fields error
          toast.error("Error in creating Project File");
        }
        else{ // mongo error
          toast.error("Duplicate Project File");
        }
      }
     
   });

  console.log(file);
  
}

const viewOriginalFile = (file, runtype) => {

  let finalFileName = fileName;
  if(file){
    finalFileName = file.name;
  }
  if(finalFileName){
    setFileUploaded(true);
    //const filePath = `/Users/murugesh.nadar/Documents/work/IMS/iqvia-emea/backend/tmp/uploads/${fileName.name}`;

    let state = {
      runtype: runtype,
      projectId,
      projectFileId,
      fileFormat,
      projectFile,
      supplier,
      fileName,
      file,
      projectFileName,
      masterProjectFileType,
      supplierNameRow,
      periodRangeRow,
      masterProjectFileTypeRow,
      dataHeaderRow,
      mergedCell,
      splitCell,
      splitCellString,
      validationColumn,
      exceptionKeywords,
      isMultipleString,
      multipleStringFormat,
      recordTypes,
      fileFormatId,
      fileFormatName,
      fileNamePattern,
      fileRecordLength,
      file_Name: finalFileName,
      delimitor,
      hasHeader,
      includeTrailer,
      metadata,
      companyNameReversed,
      companyNameInColumns,
      companyNameInRows,
      companyNameRowsCount,
      companyNameInColumnsIndex,
      isComapnyGreater,
      isBillNoinRow,
      billNoColumn,
      spaceTab,
      isFixedLength,
      fixedLengthFormat,
      addStaticHeader,
      skipRows,
      isDataInSingleColumn,
      compNameInRows,
      isCompanyAndProductSequence,
      doCaptureEmptyValidationColumnValue,
      secondaryValidationColumn,
      selectedTableName
    };

    console.log('viewOriginalFile.state', state);

    setIsLoading(true);
    ProcessFileService.viewOriginalFile({state: state, fileName: finalFileName, projectId: projectId  }).then((response) => {
      setIsLoading(false);
      console.log('response.data.output.', response.data.output);
      if(response.data.output && response.data.output){
        const output = response.data.output;
        if(output.message){
          toast.error(output.message);
          return;
        }

          let headerData = {};
          for(const key in output.headerData) {

            let itemArray = output.headerData[key];
            
            const headerData1 = itemArray.map(item => {
              console.log('isNaN(Number(item))', isNaN(Number(item)));
              return { 
                "id": key+item,
                "name": item,
                "label": isNaN(Number(item)) ? item : "Col " +item
              }
            });

            console.log('headerData1', headerData1);
            headerData[key] = headerData1;
          }

          //const headerData1 = [];


          console.log('headerData', headerData);
          console.log('output.tablePreviewData', output.tablePreviewData);
          setHeaders(headerData);
          // setHeadersArray(headerData1);
          setPreviewTable(output.tablePreviewData);
          setViewTable(true);
          setPeriodRange(output.dateRange);
          setSupplierName(output.supplierName);
          // setRows(output);
          // setHeaders(output.headerData);
          // setHeaderObjects(output.headerObject.headerData);
          // setHeaderObjectRecords(output.headerObject.rowData);
          // setTrailerObjects(output.trailerObject.headerData);
          // setTrailerObjectRecord(output.trailerObject.rowData);
        // } else {
        //   setHeaders(output.headerData);
        // }
      }
      setViewTable(true);
      setTestRunBtn(true);
    });

  } else {
    console.error('No File Name Provided');
  }

  
}

const clearData = () => {
  //setRows("");
}

const onChangeMMetadataFieldValue = (value, name) => {
  let updatedMetadata = metadata.filter(function (item) {
    if(item.metadataName === name){
     return item;
    }
  });
  updatedMetadata[0].metadataValue = value;

  setMetadata([...metadata], updatedMetadata);
}

const addMetaData = () => {
  setShowMetadata(!showMetadata);
}

const handleAddMetaData = () => {
  let metadataArray = metadata.length > 0 ? [...metadata] : [];
  metadataArray.push({
      metadataName: metaDataFieldName,
      metadataValue: metaDataFieldValue
  });
  setMetadata(metadataArray);
  setMetaDataFieldName("");
  setMetaDataFieldValue("");
}


// const resetState = () => {
//   setSupplierName("");
//   setSupplierStatmentPeriodRow("");
//   setSkipRows("");
//   setDataHeaderRow("");

//   setShowSupplierName(false);
//   setShowSupplierStatmentPeriodRow(false);
//   setShowSkipRows(false);
//   setShoDataHeaderRow(false);

//   setShowSeparator(true);
//   setShowStartDateIndex(true);
//   setShowEndDateIndex(true);
//   setShowSupplierCodeIndex(true);
// }

const totalRowProcessed = rows && rows.rowData && rows.rowData.length > 0 ? rows.rowData.length : 0 || 0;
const totalRowCount = rows && rows.totalRowCount || 0;
const totalEmptyRowCount = rows && rows.totalEmptyRowCount || 0;


console.log('Headers ============', headers);

  
  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 mb-2 pageTitle">{isClone ? 'Clone' : isEdit ? 'Edit' : isView ? 'View' : 'Create New'} File Configuration</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={2}>
            <Button
              className="btn btn-light mt-4"
              theme="accent"
              onClick={() => navigate(`/project/${projectId}/file`)}
            >
              <FcList /> View All
            </Button>
            {!isView && (
              <Button
                className="btn btn-primary mt-4"
                theme="accent"
                onClick={() => addMetaData()}
              >
                <FcPlus /> Add MetaData
              </Button>
            )}
          </Stack>
          
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <Form>
            <Row>
              <Col md="12" className="form-group">

                <Row className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="supplierSelected">Supplier</label></Col>
                      <> 
                        <Col className="form-field" md="6">
                          <FormInputText
                            id="supplierSelected"
                            placeholder="Select Supplier"
                            value={supplier && supplier.supplierName || ""}
                            setFunc={onChangeSupplierSelected}
                            disabled={true}
                          />
                        </Col>
                        <Col md="2">
                            <Button
                              className="ml-3 mt-2"
                              variant="primary"
                              onClick={handleShowModalSupplier}
                            >
                              <FcSearch /> Search Supplier
                            </Button>
                          </Col>
                        </>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Format Type</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormat
                    ) : (
                      <FormInputSelect
                        className="forminput"
                        placeholder="Select Format"
                        optionList={fileFormatList}
                        value={fileFormat}
                        setFunc={setFileFormat}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="projectStructureSelected">Select the Data Entry Tables</label></Col>
                  <Col className="form-field" md="8">
                    {projectMasterKeys.map((mitem,mindex) => {
                      return (
                        <Row key={mindex}>
                          <Col>
                            <FormCheckbox
                                className="forminput"
                                showLabel={false}
                                label={mitem.masterKeyName}
                                checked={mitem.checked}
                                item={mitem}
                                setFunc={onCheckedRecordTypeSelected}
                                disabled={isView}
                                //onChange={(e) => onCheckedProjectStructureSelected(e, mitem)}
                              />
                          </Col>
                        </Row>
                      )}
                    )}
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Input File Type</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView || isEdit) ? (
                      masterProjectFileType
                    ) : (
                        <FormInputSelect
                          className="forminput"
                          placeholder="Select Input File Type"
                          optionList={inputFileTypeList}
                          value={masterProjectFileType}
                          setFunc={setMasterProjectFileType}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 

                {/* <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Format ID</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormatId
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="File Format ID"
                          value={fileFormatId}
                          setFunc={setFileFormatId}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> */}

                {/* <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Format Name</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormatName
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="File Format Name"
                          value={fileFormatName}
                          setFunc={setFileFormatName}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> */}

                <Row  className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="projectFileName">File Configuration Name</label></Col>
                    {projectFileId ? (
                        (isEdit ? (
                          <Col className="form-field" md="8">{projectFile.projectFileName}</Col>
                        ) :(
                        <Col className="form-field" md="8">
                        <FormInputText
                            id="projectFileName"
                            placeholder="File Configuration Name"
                            value={projectFileName}
                            setFunc={setProjectFileName}
                            showLabel={false}
                            disabled={true}
                          />
                        </Col>
                    ) ) ) :(
                    <Col className="form-field" md="8">
                      <FormInputText
                          id="projectFileName"
                          placeholder="File Configuration Name"
                          value={projectFileName}
                          setFunc={setProjectFileName}
                          showLabel={false}
                          disabled={true}
                        />
                      </Col>
                        )
                      }
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Name pattern</label>
                    <br />
                    <span className="helptext">Enter the format in P10001* 
                    <br />
                    (10001 is the supplier code)</span>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileNamePattern
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="File Name Pattern"
                          value={fileNamePattern}
                          setFunc={setFileNamePattern}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>

                {/* <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Format Condition</label>
                    <br />
                    *column starts / end with character
                  </Col>
                  <Col className="form-field" md="3">
                    {(isView) ? (
                      condtionColIndex
                    ) : (
                        <FormInputSelect
                          className="forminput"
                          placeholder="Select Column Index"
                          optionList={columnIndexList}
                          value={condtionColIndex}
                          setFunc={setCondtionColIndex}
                          showLabel={false}
                        />
                    )}
                  </Col>
                  <Col className="form-field" md="3">
                    {(isView) ? (
                      condtionCol
                    ) : (
                        <FormInputSelect
                          className="forminput"
                          placeholder="Select Condition"
                          optionList={columnConditionList}
                          value={condtionCol}
                          setFunc={setCondtionCol}
                          showLabel={false}
                        />
                    )}
                  </Col>
                  <Col className="form-field" md="2">
                    {(isView) ? (
                      condtionColValue
                    ) : (
                      <FormInputText
                          className="forminput"
                          placeholder="Condition Value"
                          value={condtionColValue}
                          setFunc={setCondtionColValue}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> */}

              {fileFormat === 'fixed' && (
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Record Length</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileRecordLength
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="File Record Length"
                          value={fileRecordLength}
                          setFunc={setFileRecordLength}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 
              )}
                

                {/* <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Type</label>
                  </Col>
                  <Col className="form-field" md="8">{fileType && fileType.name}</Col>
                </Row> */}

                {fileFormat === 'delimit' || fileFormat === 'txt' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isIntermeditaryDataDatabase">has header</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <BootstrapSwitchButton
                        checked={hasHeader}
                        id="hasHeader"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => setHasHeader(val)}
                      />
                    </Col>
                  </Row>
                )}

                {fileFormat === 'delimit' || fileFormat === 'txt' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isFixedLength">is Fixed Length</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <BootstrapSwitchButton
                        checked={isFixedLength}
                        id="isFixedLength"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => setIsFixedLength(val)}
                      />
                    </Col>
                  </Row>
                )}

                {fileFormat === 'delimit' || fileFormat === 'txt' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isIntermeditaryDataDatabase">include Trailer</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <BootstrapSwitchButton
                        checked={includeTrailer}
                        id="includeTrailer"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => setIncludeTrailer(val)}
                      />
                    </Col>
                  </Row>
                )}


                {(fileFormat === 'excel' || fileFormat === 'csv' || (fileFormat === 'txt' )) && (
                  <Row>
                    <Col>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Name Row</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="supplierNameRow"
                              placeholder="Supplier Name Row"
                              className="forminput"
                              value={supplierNameRow}
                              setFunc={setSupplierNameRow}
                              showLabel={false}
                          />
                          </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Supplier Statement period Row</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="supplierStatmentPeriodRow"
                              placeholder="Period Range Row"
                              className="forminput"
                              value={periodRangeRow}
                              setFunc={setPeriodRangeRow}
                              showLabel={false}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Input File Type Row</label>
                        <br />
                        <span className="helptext">Enter the row no of keyword 'PRODUCT WISE' / 'Bill WISE'</span>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="masterProjectFileTypeRow"
                              placeholder="Input File Type Row"
                              className="forminput"
                              value={masterProjectFileTypeRow}
                              setFunc={setMasterProjectFileTypeRow}
                              showLabel={false}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="dataHeaderRow">Data Header Row</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="dataHeaderRow"
                              placeholder="Header Row"
                              className="forminput"
                              value={dataHeaderRow}
                              setFunc={setDataHeaderRow}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="mergedColumns">Columns to be Merged</label>
                        <br />
                        <span className="helptext">Enter the format in A,B</span>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="mergedColumns"
                              placeholder="Merged Row"
                              className="forminput"
                              value={mergedCell}
                              setFunc={setMergedCell}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="splitColumns">Columns to be Split</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="splitColumns"
                              placeholder="Split Column(s)"
                              className="forminput"
                              value={splitCell}
                              setFunc={setSplitCell}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      { splitCell && splitCell !== undefined && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="splitColumns">Sequence of Split Column String</label>
                          <br />
                          <span className="helptext">Enter the format in PRICE, EXP_DATE</span>
                          </Col>
                          <Col className="form-field" md="8">
                            <FormInputText
                                id="splitColumnsString"
                                placeholder="Split Column(s)"
                                className="forminput"
                                value={splitCellString}
                                setFunc={setSplitCellString}
                                showLabel={false}
                            />
                          </Col>
                        </Row>
                      )}
                      
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="validationColumn">Validation Column</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="validationColumn"
                              placeholder="Validation Column"
                              className="forminput"
                              value={validationColumn}
                              setFunc={setValidationColumn}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Exception Keywords</label>
                        <br />
                        <span className="helptext">Enter the format in Party Total:, Grand Total:</span>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              rows={4}
                              id="exceptionKeywords"
                              placeholder="Exception Keywords"
                              className="forminput"
                              value={exceptionKeywords}
                              setFunc={setExceptionKeywords}
                              showLabel={false}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Skip Rows</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="skipRows"
                              placeholder="Skip Rows"
                              className="forminput"
                              value={skipRows}
                              setFunc={setSkipRows}
                              showLabel={false}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="companyNameReversed">Is Customer & Product Reversed</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={companyNameReversed}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setCompanyNameReversed(val)}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInColumns">Is Customer Names in Column</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={companyNameInColumns}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setCompanyNameInColumns(val)}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Is Customer Names in Row</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={companyNameInRows}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setCompanyNameInRows(val)}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compNameInRows">Is Company Names in Row</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={compNameInRows}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setCompNameInRows(val)}
                          />
                        </Col>
                      </Row>

                      {companyNameInRows && (
                        <>
                          <Row  className="form-group-row">
                            <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Does columns subsequent to Customer Name has greater data count than Product Name row</label></Col>
                            <Col className="form-field" md="8">
                              <BootstrapSwitchButton
                                checked={isComapnyGreater}
                                id="isComapnyGreater"
                                onlabel="Yes"
                                offlabel="No"
                                onChange={(val) => setIsComapnyGreater(val)}
                              />
                            </Col>
                          </Row>
                          {isComapnyGreater && (
                            <>
                            <Row  className="form-group-row">
                              <Col className="form-label" md="4"><label htmlFor="companyNameRowsCount">Count of Columns with data, subsequent to the Customer Name row</label></Col>
                              <Col className="form-field" md="8">
                                <FormInputText
                                    id="companyNameRowsCount"
                                    className="forminput"
                                    placeholder="Count of Text in Row to be Excluded"
                                    value={companyNameRowsCount}
                                    setFunc={setCompanyNameRowsCount}
                                    showLabel={false}
                                  />
                              </Col>
                            </Row>
                            <Row  className="form-group-row">
                              <Col className="form-label" md="4"><label htmlFor="companyNameInColumnsIndex">Count of Columns with data, Subsequent to the Product Name row</label></Col>
                              <Col className="form-field" md="8">
                                <FormInputText
                                    id="companyNameInColumnsIndex"
                                    className="forminput"
                                    placeholder="Column Count"
                                    value={companyNameInColumnsIndex}
                                    setFunc={setCompanyNameInColumnsIndex}
                                    showLabel={false}
                                  />
                              </Col>
                            </Row>
                            </>
                          )}
                          
                        </>
                      )}

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Is Bill No In Row</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={isBillNoinRow}
                            id="isBillNoinRow"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setIsBillNoinRow(val)}
                          />
                        </Col>
                      </Row>

                      {isBillNoinRow && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="multipleStringFormat">Bill No Column</label></Col>
                          <Col className="form-field" md="8">
                            <FormInputText
                                id="billNoColumn"
                                className="forminput"
                                placeholder="Bill No Column"
                                value={billNoColumn}
                                setFunc={setBillNoColumn}
                                showLabel={false}
                              />
                          </Col>
                        </Row>
                      )}

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="isDataInSingleColumn">Is Data in single column</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={isDataInSingleColumn}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setIsDataInSingleColumn(val)}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="isCompanyAndProductSequence">Is Company And Product in sequence</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={isCompanyAndProductSequence}
                            id="hasHeader"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setIsCompanyAndProductSequence(val)}
                          />
                        </Col>
                      </Row>

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInRows">Does a column has Multiple Data Strings</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={isMultipleString}
                            id="isMultipleString"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setIsMultipleString(val)}
                          />
                        </Col>
                      </Row>

                      {isMultipleString && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="multipleStringFormat">Sequence of Multiple Data Strings</label>
                          <br />
                          <span className="helptext">Enter the format in SR_NO, PROD_CODE, PROD_NAME</span>
                          <br />
                          <span className="helptext">*PROD_NAME should be written in this format only</span>
                          </Col>
                          <Col className="form-field" md="8">
                            <FormInputText
                                id="multipleStringFormat"
                                className="forminput"
                                placeholder="Multiple String Format"
                                value={multipleStringFormat}
                                setFunc={setMultipleStringFormat}
                                showLabel={false}
                              />
                          </Col>
                        </Row>
                      )}

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="doCaptureEmptyValidationColumnValue">Capture Empty Customer Values</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={doCaptureEmptyValidationColumnValue}
                            id="doCaptureEmptyValidationColumnValue"
                            onlabel="Yes"
                            offlabel="No"
                            onChange={(val) => setDoCaptureEmptyValidationColumnValue(val)}
                          />
                        </Col>
                      </Row>

                      {doCaptureEmptyValidationColumnValue && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="secondaryValidationColumn">Secondary Validation Column</label>
                          </Col>
                          <Col className="form-field" md="8">
                            <FormInputText
                                id="secondaryValidationColumn"
                                placeholder="Secondary Validation Column"
                                className="forminput"
                                value={secondaryValidationColumn}
                                setFunc={setSecondaryValidationColumn}
                                showLabel={false}
                            />
                          </Col>
                        </Row>
                      )}

                      {isFixedLength && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="fixedLengthFormat">Length of Multiple Data Strings</label>
                          <br />
                          <span className="helptext">Enter the format in 4, 46, 9, 26, 13, 9, 5, 7</span>
                          </Col>
                          <Col className="form-field" md="8">
                            <FormInputText
                                id="fixedLengthFormat"
                                className="forminput"
                                placeholder="Multiple String Format Length"
                                value={fixedLengthFormat}
                                setFunc={setFixedLengthFormat}
                                showLabel={false}
                              />
                          </Col>
                        </Row>
                      )}

                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Supplier Name</label></Col>
                        <Col className="form-field" md="8">
                          {supplierName}
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Report Date Range </label></Col>
                        <Col className="form-field" md="8">
                          {periodRange && (periodRange.join(" To "))}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  
                  )
                }

                <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">Add Static Header</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {(isView) ? (
                        addStaticHeader
                      ) : (
                        <FormInputText
                            className="forminput"
                            placeholder="Add Static Header"
                            value={addStaticHeader}
                            setFunc={setAddStaticHeader}
                            showLabel={false}
                          />
                      )}
                    </Col>
                  </Row>

                {fileFormat === 'delimit' || fileFormat === 'txt' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">Delimit Character</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {(isView) ? (
                        delimitor
                      ) : (
                        <FormInputText
                            className="forminput"
                            placeholder="Delimitor"
                            value={delimitor}
                            setFunc={setDelimitor}
                            showLabel={false}
                          />
                      )}
                    </Col>
                  </Row>
                )}

                <Row  className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="spaceTab">Space Tab</label></Col>
                  <Col className="form-field" md="8">
                    <FormInputText
                        id="spaceTab"
                        className="forminput"
                        placeholder="Count of Spaces to split the merged data"
                        value={spaceTab}
                        setFunc={setSpaceTab}
                        showLabel={false}
                      />
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="feFirstName">Select File</label></Col>
                  <Col className="form-field" md="8">
                      <div className="custom-file">
                        <input 
                            type="file" 
                            className="custom-file-input" 
                            id="file" 
                            name="file"
                            placeholder="Upload your excel file"
                            onChange={readFile}
                        />
                        <label className="custom-file-label" htmlFor="customFile2">
                          Choose file...
                        </label>
                      </div>
                      {projectFileId && (
                        <div><FcApproval /> Uploaded Name : {fileName}</div>
                      )}
                      {fileUploaded && (
                        <div><FcApproval /> File Name : {file && file.name}</div>
                      )}
                  </Col>
                </Row>
                
                {fileFormat === "access" && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="tableName">Enter Table Name</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {(isView) ? (
                        selectedTableName
                      ) : (
                        // <FormInputSelect
                        //   className="forminput"
                        //   placeholder="Select Table"
                        //   optionList={tableList}
                        //   value={selectedTableName}
                        //   setFunc={setSelectedTableName}
                        //   showLabel={false}
                        // />
                        <FormInputText
                          id="selectedTableName"
                          placeholder="Enter Table Name"
                          value={selectedTableName}
                          setFunc={setSelectedTableName}
                          showLabel={false}
                        />
                      )}
                    </Col>
                  </Row>
                )}

                {metadata && metadata.map((mdItem, mdIndex) => {
                    return (
                      <Row className="form-group-row border-bottom-button ml-2 mr-2"  key={`metadata-${mdIndex} + 1`}>
                        <Col className="form-label" md="4">
                          {mdItem.metadataName}
                        </Col>
                        <Col className="form-field" md="6">
                          {(isView) ? (
                            `${mdItem.metadataValue}`
                          ) : (
                            <FormInputText
                                id={`metadataValue-${mdIndex}`}
                                placeholder="Metadata Value"
                                value={mdItem.metadataValue}
                                name={mdItem.metadataName}
                                setFunc={onChangeMMetadataFieldValue}
                                showLabel={false}
                              />
                          )}
                          </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                    );
                })}

                {showMetadata && !isView && (
                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                    <Col className="form-field" md="12">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          Meta Data Name:
                        </Col>
                        <Col className="form-field" md="6">
                          Meta Data Value:
                        </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                            <FormInputText
                              id="metadataName"
                              placeholder="Metadata Name"
                              value={metaDataFieldName}
                              setFunc={setMetaDataFieldName}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="6">
                            <FormInputText
                              id="metadataValue"
                              placeholder="Metadata Value"
                              value={metaDataFieldValue}
                              setFunc={setMetaDataFieldValue}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="2">
                          <Button variant="primary" onClick={() => handleAddMetaData()}>
                              {/* <FcPlus size="16" />  */}
                              Add 
                            </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                <Row className="form-group-row">
                  <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">Record Type Mapping</label></Col>
                </Row>

                {recordTypes && recordTypes.map((mitem,mindex) => {
                  return (
                    <Row key={mindex}>
                      <Col>
                      {mitem.checked && (
                        <>
                          <Row className="form-group-row">
                            <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">{mitem.masterKeyName}</label></Col>
                          </Row>

                          {/* <Row className="form-group-row">
                            <Col className="form-label" md="3">
                              <label htmlFor="feFirstName">File Format Condition</label>
                              <br />
                              *column starts / end with character
                            </Col>
                            <Col className="form-field" md="3">
                              {(isView) ? (
                                mitem.condtionColIndex
                              ) : (
                                  <FormInputSelect
                                    className="forminput"
                                    placeholder="Select Column Index"
                                    optionList={columnIndexList}
                                    value={mitem.condtionColIndex}
                                    item={mitem}
                                    setFunc={handleCondtionColIndexChange}
                                    showLabel={false}
                                  />
                              )}
                            </Col>
                            <Col className="form-field" md="3">
                              {(isView) ? (
                                mitem.condtionCol
                              ) : (
                                  <FormInputSelect
                                    className="forminput"
                                    placeholder="Select Condition"
                                    optionList={columnConditionList}
                                    value={mitem.condtionCol}
                                    item={mitem}
                                    setFunc={handleCondtionColChange}
                                    showLabel={false}
                                  />
                              )}
                            </Col>
                            <Col className="form-field" md="3">
                              {(isView) ? (
                                mitem.condtionColValue
                              ) : (
                                <FormInputText
                                    className="forminput"
                                    placeholder="Condition Value"
                                    value={mitem.condtionColValue}
                                    name={mitem._id}
                                    setFunc={handleCondtionColValueChange}
                                    showLabel={false}
                                  />
                              )}
                            </Col>
                          </Row> */}

                          {fileFormat === 'fixed' && (
                            <Row className="form-group-row">
                              <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                              <Col className="form-label" md="3"><label htmlFor="startPosition">Start Position</label></Col>
                              <Col className="form-label" md="3"><label htmlFor="endPosition">End Position</label></Col>
                              <Col className="form-label" md="3"><label htmlFor="positionLength">Position Length</label></Col>
                           </Row>
                          )}
                          {fileFormat === 'delimit' && (
                            <Row className="form-group-row">
                              <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                              <Col className="form-label" md="9"><label htmlFor="startPosition">Target Column Mapping</label></Col>
                           </Row>
                          )}
                          {(fileFormat === 'excel' || fileFormat === 'csv' || fileFormat === 'txt' || fileFormat === 'access') && (
                            <Row className="form-group-row">
                              <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                              <Col className="form-label" md="9"><label htmlFor="startPosition">Target Column Mapping</label></Col>
                           </Row>
                          )}
                          
                          {mitem.masterKeyFields.map((mRitem,mRindex) => {
                            return (
                              <Row key={mRindex}>
                                <Col>  
                                  {fileFormat === 'fixed' && (                         
                                    <Row className="form-group-row" key={mRindex}>
                                      <Col className="form-label" md="3"><label htmlFor="feFirstName">{mRitem.fieldName}</label></Col>
                                      <Col className="form-field" md="3">
                                        <FormInputText
                                          type="number"
                                          className="forminput"
                                          placeholder="Start Position"
                                          value={mRitem.startPosition}
                                          name={mRitem.fieldName}
                                          setFunc={handleStartPositionChange}
                                          showLabel={false}
                                          disabled={isView}
                                          keyName={mitem.masterKeyName}
                                        />
                                      </Col>
                                      <Col className="form-field" md="3">
                                        <FormInputText
                                          type="number"
                                          className="forminput"
                                          placeholder="End Position"
                                          value={mRitem.endPosition}
                                          name={mRitem.fieldName}
                                          setFunc={handleEndPositionChange}
                                          showLabel={false}
                                          disabled={isView}
                                          keyName={mitem.masterKeyName}
                                        />
                                      </Col>
                                      <Col className="form-field" md="3">
                                        <FormInputText
                                          type="number"
                                          className="forminput"
                                          placeholder="Position length"
                                          value={mRitem.positionLength}
                                          name={mRitem.fieldName}
                                          setFunc={handlePositionLengthChange}
                                          showLabel={false}
                                          disabled={isView}
                                          keyName={mitem.masterKeyName}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  {fileFormat === 'delimit' && (                 
                                    <Row className="form-group-row" key={mRindex}>
                                      <Col className="form-label" md="3"><label htmlFor="feFirstName">{mRitem.fieldName}</label></Col>
                                      <Col className="form-field" md="8">
                                        <FormInputSelect
                                          name={mRitem.source || mRitem.fieldName} 
                                          id={mRitem.source || mRitem.fieldName}
                                          className="forminput"
                                          placeholder="Select Target Field"
                                          optionList={headers && headers[mitem.masterKeyName]}
                                          value={mRitem.target}
                                          setFunc={handleHeaderChange}
                                          showLabel={false}
                                          item={mRitem.source || mRitem.fieldName}
                                          keyName={mitem.masterKeyName}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                  {(fileFormat === 'excel' || fileFormat === 'csv' || fileFormat === 'txt' || fileFormat === 'access') && (
                                    <Row className="form-group-row">
                                      <Col className="form-label" md="3"><label htmlFor="feFirstName">{mRitem.fieldName}</label></Col>
                                      <Col className="form-field" md="8">
                                        {fileUploaded ? ( // if previously uploaded
                                          <FormInputSelect
                                            name={mRitem.source || mRitem.fieldName} 
                                            id={mRitem.source || mRitem.fieldName}
                                            className="forminput"
                                            placeholder="Select Target Field"
                                            optionList={headers && headers[mitem.masterKeyName]}
                                            value={mRitem.target}
                                            setFunc={handleHeaderChange}
                                            showLabel={false}
                                            item={mRitem.source || mRitem.fieldName}
                                            keyName={mitem.masterKeyName}
                                          />
                                        ):(
                                          <FormSelect 
                                            name={mRitem.target} 
                                            id={mRitem.target} 
                                            onChange={handleHeaderChange}>
                                              {mRitem.target && (
                                                <>
                                                {isNaN(mRitem.target) ? (
                                                  <option key={mindex+1+10} value={mRitem.target} selected>{mRitem.target}</option>
                                                ): (
                                                  <option key={mindex+1+10} value={mRitem.target} selected>Col {mRitem.target}</option>
                                                )}
                                                </>
                                                
                                              )}
                                              <option>Select Target Field</option>
                                          </FormSelect>
                                        )}
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                            )
                          })}
                        </>
                      )}
                    </Col>
                   </Row>
                  )
                })}
                

                

                

                <Row  className="form-group-row">
                  <Col className="form-button" md="4">
                    {testRunBtn && (
                      <>
                      <Button className="btn btn-primary float-left mr-3" onClick={() => {viewOriginalFile(file)}} theme="accent"><FcDataConfiguration /> Test Run</Button>
                    </>
                    )}
                  </Col>
                  <Col className="form-button" md="4">
                    {/* {testRunBtn && (
                      <>
                      {`Total Rows Count: ${totalRowCount}`}
                      <br />
                      {`Total Rows processed: ${totalRowProcessed}`}
                      </>
                    )} */}
                  </Col>
                  <Col className="form-button" md="4">
                    {(isEdit || isCreate || isClone) && (
                      <Button
                        className="btn btn-primary"
                        theme="accent"
                        onClick={() => createEditProjectFile()}
                      >
                        <FcPlus /> {isClone ? 'Clone' : isEdit ? 'Update' : 'Create' } Project File
                      </Button>
                    )}
                    {(isView) && (
                      <Button
                        className="btn btn-primary"
                        theme="accent"
                        onClick={() => navigate(`/project/${projectId}/file/${projectFileId}/edit`)}
                      >
                        <TiEdit /> Edit Project File
                      </Button>
                    )}
                  </Col>
                </Row>  

              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <hr />

      {viewTable && (
        <>
          {
            Object.keys(previewTable).map(function(key) {
              return ( 
                <Row key={key}>
                  <Col>
                    {previewTable[key] && previewTable[key].rowData && previewTable[key].rowData.length > 0 && (
                      <>
                        <Row>
                          <Col className="mb-2">Data for {key}</Col>
                        </Row>
                        <Container>
                            <Row>
                                <TableRow
                                    rows={previewTable[key]}
                                    clearData={clearData}
                                />
                            </Row>
                        </Container>
                      </>
                    )}
                  </Col>
                </Row>
              )
            })
          }
          
        </>
      )}

      <Modal show={showModalSupplier} size="lg" onHide={handleCloseModalSupplier}>
        <Modal.Header>
          <Modal.Title className="pageTitle">Search Supplier</Modal.Title>
          <div
            className="closeBtn"
            onClick={handleCloseModalSupplier}
            aria-label="Close"
          >
            <TiDeleteOutline size={25} />
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="form-group-row">
              {/* <Col className="form-label" md="4">
                <label htmlFor="supplierName">Supplier Name</label>
              </Col> */}
              <Col className="form-field" md="3">
                <FormInputText
                  id="supplierNameTxt"
                  placeholder="supplier Name"
                  value={supplierNameTxt}
                  setFunc={onChangeSupplierNameTxt}
                  showLabel={false}
                />
              </Col>
              <Col className="form-label text-center" md="1">
              or
              </Col>
              <Col className="form-field" md="3">
                <FormInputText
                  id="supplierCodeTxt"
                  placeholder="supplier Code"
                  value={supplierCodeTxt}
                  setFunc={onChangeSupplierCodeTxt}
                  showLabel={false}
                />
              </Col>
              <Col className="form-label text-center" md="1">
              or
              </Col>
              <Col className="form-field" md="4">
                <FormInputText
                  id="supplierAddressTxt"
                  placeholder="supplier Address"
                  value={supplierAddressTxt}
                  setFunc={onChangeSupplierAddressTxt}
                  showLabel={false}
                />
              </Col>
            </Row>
            <Row className="form-group-row">
              <Col className="form-label" md="2">
                <label htmlFor="feFirstName">Supplier Name</label>
              </Col>
              <Col className="form-label" md="2">
                <label htmlFor="feFirstName">Supplier Code / ID</label>
              </Col>
              <Col className="form-label" md="6">
                <label htmlFor="feFirstName">Supplier Address</label>
              </Col>
              <Col className="form-label" md="2">
                <label htmlFor="feFirstName">Select</label>
              </Col>
            </Row>
              
            {supplierFilteredList && supplierFilteredList.map((item,index) => {
              return (
                <Row className="form-group-row" key={item.supplierCode}>
                  <Col className="form-field" md="2">
                    <label htmlFor="feSupplierName">{item.supplierName}</label>
                  </Col>
                  <Col className="form-field" md="2">
                    <label htmlFor="feSupplierCode">{item.supplierCode}</label>
                  </Col>
                  <Col className="form-field" md="6">
                    <label htmlFor="feSupplierAddress">{item.supplierAddress}</label>
                  </Col>
                  <Col className="form-field" md="2">
                  <Button
                      className="ml-3 mt-2"
                      variant="primary"
                      onClick={() => selectSupplier(item.id)}
                    >
                      <FcPlus /> Select
                    </Button>
                  </Col>
                </Row>
              )
            })
          }
          
          </Form>
        </Modal.Body>
      </Modal>
      
    </Container>
  );
}

export default ProjectFileCreate;
